<template>
    <div class="productList" ref="container">
        <div style="background:#fff;position:sticky;top:0;z-index: 11;">
            <div class="bg-img">
                <div class="search bg-img acea-row row-between-wrapper">
                    <div class="input acea-row row-between-wrapper">
                        <span class="iconfont icon-sousuo"></span>
                        <input placeholder="搜索商品信息" v-model="where.keyword" />
                    </div>
                    <button class="search-goods" @click="submitForm">搜索</button>
                </div>
                <div class="tab">
                    <div class="tab-child" id="tab-child">
                        <div class="tabs" id="tabs" v-for="(item,index) in dataSource" :key="index" @click="selectCate(item.id,index)">
                            <img :class="selectIndex==index ?'select':''" v-lazy="item.image"  alt="">
                            <div>{{item.cate_name}}</div>
                        </div>
                    </div>
                    <div class="more" id="more"  @click="selectMore">
                      <div>更多</div>
                      <img src="../../assets/newImg/more_right_icon.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div style="height:.25rem;position:fixed;top:3.5rem;background:#fff;width:100%;z-index:10"></div>
        <div class="nav acea-row row-middle">
            <!-- <div
        class="item"
        :class="title ? 'font-color-red' : ''"
        @click="set_where(0)"
      >
        {{ title ? title : "默认" }}
      </div> -->
            <div class="item" :class="nows ? 'font-color-red' : ''" @click="set_where(3)">
                新品
            </div>
            <div class="item" @click="set_where(1)">
                价格
                <img src="@assets/images/horn.png" v-if="price === 0" />
                <img src="@assets/images/up.png" v-if="price === 1" />
                <img src="@assets/images/down.png" v-if="price === 2" />
            </div>
            <div class="item" @click="set_where(2)">
                销量
                <img src="@assets/images/horn.png" v-if="stock === 0" />
                <img src="@assets/images/up.png" v-if="stock === 1" />
                <img src="@assets/images/down.png" v-if="stock === 2" />
            </div>
            <!-- down -->
            <div class="item">
                <div class="iconfont" :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'" @click="switchTap"></div>
            </div>
        </div>
        <div class="list acea-row row-between-wrapper" :class="Switch === true ? '' : 'on'" ref="container">
            <div @click="goDetail(item)" v-for="(item, index) in productList" :key="index" class="item" :class="Switch === true ? '' : 'on'" :title="item.store_name">
                <div class="pictrue" :class="Switch === true ? '' : 'on'">
                    <img :src="item.image" :class="Switch === true ? '' : 'on'" />
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
                    <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
                </div>
                <div class="text" :class="Switch === true ? '' : 'on'">
                    <div class="name line1">{{ item.store_name }}</div>
                    <div class="name line1" style="color:#999999;font-size:12px;height:20px;line-height:20px">
                        {{ item.store_info }}
                    </div>
                    <!-- <div
                        class="money font-color-red"
                        :class="Switch === true ? '' : 'on'"
                    >
                        ￥<span class="num">{{ item.price }}</span>
                    </div> -->
                    <!-- <div
                        class="vip acea-row row-between-wrapper"
                        :class="Switch === true ? '' : 'on'"
                    >
                        <div
                            class="vip-money"
                            v-if="item.vip_price && item.vip_price > 0"
                        >
                            ￥{{ item.vip_price
                            }}<img src="@assets/images/vip.png" />
                        </div>
                        <div>已售{{ item.sales }}件</div>
                    </div> -->
                    <div class="go-shop">
                        <div class="money font-color-red row-flex" :class="Switch === true ? '' : 'on'">
                            ￥<span class="num">{{ item.price }}</span>
                            <div class="span" v-if="item.gains!=0">
                                <img src="../../assets/images/icon_up.png" alt="" v-if="item.gains==1"/>
                                <img src="../../assets/images/icon_down.png" alt="" v-if="item.gains==2" />
                                <div style="color:#D01112">{{item.gains_num}}%</div>
                            </div>
                        </div>
                       
                    </div>
                     <div class="go">
                            立即购买
                        </div>
                </div>
            </div>
        </div>
        <Loading :loaded="loadend" :loading="loading"></Loading>
        <div class="noCommodity" v-cloak style="background-color: #fff;" v-if="productList.length === 0 && where.page > 1">
            <div class="noPictrue">
                <img src="@assets/images/noGood.png" class="image" />
            </div>
        </div>
        <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend>
        <div style="height:1.2rem;"></div>
    </div>
</template>

<script>
import Recommend from "@components/Recommend";
import { getProducts } from "@api/store";
import {categoryList} from '@api/user';
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";

export default {
    name: "GoodsList",
    components: {
        Recommend,
        Loading,
    },
    props: {},
    data: function () {
        const { s = "", id = 0, title = "" } = this.$route.query;

        return {
            hostProduct: [],
            productList: [],
            Switch: true,
            where: {
                page: 1,
                limit: 8,
                keyword: s,
                sid: id, //二级分类id
                news: 0,
                priceOrder: "",
                salesOrder: "",
                shop_type:1,
            },
            title: title && id ? title : "",
            loadTitle: "",
            loading: false,
            loadend: false,
            price: 0,
            stock: 0,
            nows: false,
            dataSource:[],
            selectIndex:0,
            number:1
        };
    },
    watch: {
        title() {
            this.updateTitle();
        },
        $route(to) {
            if (to.name !== "GoodsList") return;
            const { s = "", id = 0, title = "" } = to.query;
            if (s !== this.where.keyword || id !== this.where.sid) {
                this.where.keyword = s;
                this.loadend = false;
                this.loading = false;
                this.where.page = 1;
                this.where.sid = id;
                this.title = title && id ? title : "";
                this.nows = false;
                this.$set(this, "productList", []);
                this.price = 0;
                this.stock = 0;
                this.get_product_list();
            }
        }
    },
    mounted: function () {
        // this._onShowLoading();
        this.updateTitle();
        this.cateList();
        this._onQueryBindAccount();
        this.get_product_list();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_product_list();
        });
    },
    methods: {
        // 商品详情跳转
        goDetail(item) {
            goShopDetail(item).then(() => {
                this.$router.push({ path: "/detail/" + item.id });
            });
        },
        updateTitle() {
            document.title = this.title || this.$route.meta.title;
            let type = this.$route.query.type,
                title = this.$route.query.title;
            if (type == "search") {
                this.where.keyword = title;
            }
        },
        /**点击分类刷新 */
        selectCate(id,index){
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.where.sid = id;
            this.selectIndex=index;
            this.get_product_list();
        },
        get_product_list: debounce(function () {
            var that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            this.setWhere();
            let q = that.where;
            let historyList =
                JSON.parse(localStorage.getItem("historyList")) || [];
            getProducts(q).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data);
                that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
                that.where.page = that.where.page + 1;
                /**缓存搜索结果 */
                historyList.push(that.where.keyword);
                let set = new Set(historyList);
                localStorage.setItem("historyList", JSON.stringify([...set]));
            });
            setTimeout(() => that._onHideLoading(), 1000)
        }, 300),
        submitForm: function () {
            this.$set(this, "productList", []);
            this.where.page = 1;
            this.loadend = false;
            this.loading = false;
            this.get_product_list();
        },
        //点击事件处理
        set_where: function (index) {
            let that = this;
            switch (index) {
                case 0:
                    return that.$router.push({ path: "/category" });
                case 1:
                    if (that.price === 0) that.price = 1;
                    else if (that.price === 1) that.price = 2;
                    else if (that.price === 2) that.price = 0;
                    that.stock = 0;
                    break;
                case 2:
                    if (that.stock === 0) that.stock = 1;
                    else if (that.stock === 1) that.stock = 2;
                    else if (that.stock === 2) that.stock = 0;
                    that.price = 0;
                    break;
                case 3:
                    that.nows = !that.nows;
                    break;
                default:
                    break;
            }
            that.$set(that, "productList", []);
            that.where.page = 1;
            that.loadend = false;
            that.get_product_list();
        },
        //设置where条件
        setWhere: function () {
            let that = this;
            if (that.price === 0) {
                that.where.priceOrder = "";
            } else if (that.price === 1) {
                that.where.priceOrder = "asc";
            } else if (that.price === 2) {
                that.where.priceOrder = "desc";
            }
            if (that.stock === 0) {
                that.where.salesOrder = "";
            } else if (that.stock === 1) {
                that.where.salesOrder = "asc";
            } else if (that.stock === 2) {
                that.where.salesOrder = "desc";
            }
            that.where.news = that.nows ? "1" : "0";
        },
        switchTap: function () {
            let that = this;
            that.Switch = !that.Switch;
        },
        cateList(){
            categoryList().then(res=>{
               this.dataSource=res.data.data.store_category_list
            })
        },
        selectMore(index){
            let number=this.number
            document.getElementById('tab-child').scrollLeft=100*number
            // console.log( document.getElementById('tab-child').scrollLeft)
            this.number++
        },
    },
};
</script>
<style scoped>
.noCommodity {
    border-top: 3px solid #f5f5f5;
    padding-bottom: 1px;
}
.search-goods {
    padding-right: 11px;
    color: #fff;
    font-size: 13px;
}
.tab {
    height: 2rem;
    background: #ffffff;
    border-radius: 0.2rem;
    left: 0.22rem;
    right: 0.22rem;
    box-shadow: 0px 0.08rem 0.1rem 0px rgba(228, 228, 228, 0.82);
    display: flex;
    position: fixed;
    top: 1.5rem;
    z-index: 11;
    align-items: center;
}
.tab .more {
    background: url("../../assets/newImg/tab_more_icon.png") no-repeat;
    background-size: 100% 100%;
    width: 1.64rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: .2rem;
    box-sizing: border-box;
}
.tab .more div{
  font-size: .28rem;
  color: #D01112;
}
.tab .more  img{
  margin-left: .11rem;
  width: .2rem;
  height: .24rem;
}
.tab .tab-child {
    padding: 0.3rem 0 0 0.3rem;
    /* flex: 1; */
    width: 100%;
    overflow-x: scroll;
    display: flex;
    box-sizing: border-box;
    /* padding-left: 20px; */
}
.tab .tab-child .tabs {
    
    /* margin-right: 0.44rem; */
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 10px;

}
.tab .tab-child .tabs img {
    width: 0.88rem;
    height: 0.88rem;
    border: 0.02rem solid #eeeeee;
    display: block;
    margin: 0 auto;
    border-radius: 100%;
}
.tab .tab-child .tabs img.select {
    border: 0.02rem solid #D01112;
}
.tab .tab-child .tabs div {
    font-size: 0.26rem;
    color: #333333;
    /*width: 1.04rem;*/
    width: max-content;
    margin-top: 0.1rem;
    text-align: center;
}
.productList .search .input {
    background: rgba(255, 255, 255, 0.4);
    display: flex;
    align-items: center;
}
.productList .search .input input {
    color: #fff;
}
.productList .search .input ::placeholder {
    color: #fff;
}
.productList .search .input .iconfont {
    color: #fff;
}
.productList .search {
    top: 0.25rem;
}
.productList .nav {
    top: 3.75rem;
}
.bg-img {
    height: 3.5rem;
    width: 100%;
    background: url("../../assets/newImg/index_bg.png") no-repeat;
    background-size: 100% 100%;
    position: sticky;
    top: 0;
}
.productList .list .item .pictrue {
    height: 194px;
}
.productList .list .item {
    height: 305px;
    box-shadow: 0px 2px 30px 0px rgba(157, 157, 157, 0.2);
}
.go-shop {
    /* height: 33px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
}
 .go {
    width: 64px;
    height: 20px;
    background: #d01112;
    border-radius: 13px;
    line-height: 20px;
    color: #fff;
    background: #d01112;
    font-size: 12px;
    text-align: center;
    float: right;
}
.on .go{
    width: 64px;
    height: 20px;
    background: #d01112;
    border-radius: 13px;
    line-height: 20px;
    color: #fff;
    background: #d01112;
    font-size: 12px;
    text-align: center;
    position: absolute;
    right: 0;
    bottom: 0;
}
.productList .list .item.on {
    height: 120px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    margin-bottom: 10px;
    padding: 0;
    display: flex;
    align-items: center;
}
.productList .list {
    margin-top: 1.2rem;
}
.productList .list .item .pictrue.on {
    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.productList .list .item .pictrue img.on {
    width: 110px;
    height: 110px;
    margin-left: 6px;
}

.productList .list.on {
    margin-top: 1.2rem;
    background-color: #fff;
}
.productList .list.on .name {
    padding-top: 4px;
}
.productList .list .item .text.on {
    width: 4.68rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}
.productList .list .item.on .go-shop {
    width: 100%;
}
.productList .list .item .text .money.on {
    margin-top: 0;
}
.span{
  display: flex;
  align-items: center;
  margin-left:10px ;
}
.span img{
  width: 15px;
  height: 9px;
}
.span div{
  padding-left: 5px;
}
</style>
